import type { RouteRecordRaw } from "vue-router";
import { RouteName } from "@/apps/dashboard/router/RouteName";
import { navigationGuardForRedirectedDashboardUser } from "./guards/navigationGuardForDashboardUser.ts";
import { dashboardTranslationGuard } from "@/router/translationGuards";

// Lazy-loaded view components for code splitting
const AddInconsoleMsgView = () =>
	import("@/apps/dashboard/views/inconsole-messages/AddInconsoleMsgView.vue");
const ListInconsoleMsgView = () =>
	import("@/apps/dashboard/views/inconsole-messages/ListInconsoleMsgView.vue");
const AddCreditCardShipmentView = () =>
	import("@/apps/dashboard/views/AddCreditCardShipmentView.vue");
const CreditCardShippingAddressEmulatorView = () =>
	import(
		"@/apps/credit-line/views/CreditCard/CreditCardShippingAddressEmulatorView.vue"
	);
const MarkShipmentAsDeliveredView = () =>
	import("../views/MarkShipmentAsDeliveredView.vue");
const DetailedTransactionsView = () =>
	import("@/apps/dashboard/views/DetailedTransactionsView.vue");
const BulkCardDisablingToolView = () =>
	import("@/apps/dashboard/views/BulkCardDisablingToolView.vue");
const OperationHoursView = () =>
	import("@/apps/dashboard/views/OperationHoursView.vue");

const routes: Array<RouteRecordRaw> = [
	{
		path: "/dashboard",
		name: RouteName.PJD_DashboardHome,
		component: () => import("@/apps/dashboard/views/DashboardHomeView.vue"),
		beforeEnter: [
			navigationGuardForRedirectedDashboardUser,
			dashboardTranslationGuard,
		],
	},
	{
		path: "/dashboard/in-console-messages",
		name: RouteName.PJD_InconsoleMessageList,
		component: ListInconsoleMsgView,
		beforeEnter: [
			navigationGuardForRedirectedDashboardUser,
			dashboardTranslationGuard,
		],
	},
	{
		path: "/dashboard/in-console-messages/add",
		name: RouteName.PJD_InconsoleMessageAdd,
		component: AddInconsoleMsgView,
		beforeEnter: [
			navigationGuardForRedirectedDashboardUser,
			dashboardTranslationGuard,
		],
	},
	{
		path: "/dashboard/add-credit-card-shipment",
		name: RouteName.PJD_AddCreditCardShipment,
		component: AddCreditCardShipmentView,
		beforeEnter: [
			navigationGuardForRedirectedDashboardUser,
			dashboardTranslationGuard,
		],
	},
	{
		path: "/dashboard/shipment-address-testing",
		name: RouteName.PJD_CreditCardShipmentAddressTesting,
		component: CreditCardShippingAddressEmulatorView,
		beforeEnter: [
			navigationGuardForRedirectedDashboardUser,
			dashboardTranslationGuard,
		],
	},
	{
		path: "/dashboard/report-delivered-shipments",
		name: RouteName.PJD_MarkShipmentAsDelivered,
		component: MarkShipmentAsDeliveredView,
		beforeEnter: [
			navigationGuardForRedirectedDashboardUser,
			dashboardTranslationGuard,
		],
	},
	{
		path: "/dashboard/detailed-transactions/:id?",
		name: RouteName.PJD_DetailedTransactions,
		component: DetailedTransactionsView,
		beforeEnter: [dashboardTranslationGuard],
	},
	{
		path: "/dashboard/bulk-card-disabling-tool",
		name: RouteName.PJD_BulkCardDisablingTool,
		component: BulkCardDisablingToolView,
		beforeEnter: [
			navigationGuardForRedirectedDashboardUser,
			dashboardTranslationGuard,
		],
	},
	{
		path: "/dashboard/operation-hours",
		name: RouteName.PJD_OperationHours,
		component: OperationHoursView,
		beforeEnter: [navigationGuardForRedirectedDashboardUser],
	},
	{
		path: "/dashboard/shipment-configuration-tool",
		name: RouteName.PJD_ShipmentConfigurationTool,
		component: () =>
			import("@/apps/dashboard/views/ShipmentConfigurationToolView.vue"),
		beforeEnter: [
			navigationGuardForRedirectedDashboardUser,
			dashboardTranslationGuard,
		],
	},
];

export default routes;
